export default __webpack_public_path__ + "static/media/nft-4.ad500cb8.png";